module.exports = __webpack_public_path__ + "images/hikakakustep_ef2d51d3467ce6f53ad542036dfaef9a.jpg";